import { render, staticRenderFns } from "./Livestream.vue?vue&type=template&id=18df3385&scoped=true&"
import script from "./Livestream.vue?vue&type=script&lang=js&"
export * from "./Livestream.vue?vue&type=script&lang=js&"
import style0 from "./Livestream.vue?vue&type=style&index=0&id=18df3385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df3385",
  null
  
)

export default component.exports